/**
 * @file Which run an archive chip opens. Consumer: `useAnalyticsReportArchive`.
 * The caller's own run at that instant opens whatever its status. Otherwise,
 * for an admin, the first uid of the definition's `recipientUids` with a
 * completed run then opens as "Run for <name>"; a completed run of someone no
 * longer listed is skipped. With neither, the result carries a failed or
 * refused run at that instant for its marker.
 */
import type {
  AnalyticsArchivedRun,
  AnalyticsReportPreviewRun,
} from './analyticsReportsTab.types';

export const analyticsReportPreviewRun = ({
  runs,
  scheduledAt,
  uid,
  recipientUids,
}: {
  runs: readonly AnalyticsArchivedRun[];
  scheduledAt: string;
  uid: string;
  recipientUids: readonly string[];
}): AnalyticsReportPreviewRun => {
  const atInstant = runs.filter(({ run }) => run.scheduledAt === scheduledAt);
  const own = atInstant.find(({ run }) => run.recipientUid === uid);
  if (own) return { status: 'own', ...own };
  for (const recipientUid of recipientUids) {
    const entry = atInstant.find(
      ({ run }) => run.recipientUid === recipientUid,
    );
    if (entry?.run.status === 'completed')
      return { status: 'recipient', runId: entry.runId, run: entry.run };
  }
  return {
    status: 'none',
    run: (
      atInstant.find(({ run }) => run.status !== 'completed') ?? atInstant[0]
    )?.run,
  };
};
